import styled from 'styled-components'

export default styled.main`
  p{
    margin-bottom: 1rem;
  }
`



// WEBPACK FOOTER //
// ./src/components/Page.js